import React from 'react';

import { TableView as TableViewIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { CompanyType } from 'src/api';
import { DetailPageLayout } from 'src/components/common';
import { PeosDetailsWallet } from 'src/components/peo';
import { ModalId } from 'src/constants/modals';
import { usePeoParamId } from 'src/hooks/peo';
import { useModalV2 } from 'src/hooks/shared';
import { RevenueShareReportGeneratingModal } from 'src/modals/billing';

export const PeoDetailBillingPage: React.FC = () => {
  const peoId = usePeoParamId();
  const { openModal } = useModalV2();

  const handleRevenueShareReportClick = React.useCallback(() => {
    openModal(RevenueShareReportGeneratingModal, {
      id: ModalId.RevenueShareReportGenerating,
      companyId: peoId,
      companyType: CompanyType.Peo,
    });
  }, [peoId, openModal]);

  return (
    <DetailPageLayout
      titleContent="Billing"
      topRightContent={
        <Button
          variant="contained"
          size="small"
          onClick={handleRevenueShareReportClick}
          startIcon={<TableViewIcon />}
        >
          Generate report
        </Button>
      }
    >
      <PeosDetailsWallet />
    </DetailPageLayout>
  );
};
